import React from 'react';

const SPAN_CLASSES = {
  auto: '',
  wide: 'col-span-2',
  full: 'col-span-2 sm:col-span-3',
};

const fieldContent = (children, value) => {
  const content = children !== undefined ? children : value;
  return content == null || content === '' ? '—' : content;
};

/**
 * Responsive read-only facts grid.
 *
 * Atomic facts use two columns on phones and three from `sm` upward.
 * Consumers widen fields by content shape, not by placing every fact on its
 * own row: `wide` for long identifiers and `full` for narrative/grouped data.
 */
export const DetailFieldGrid = ({ children, className = '' }) => (
  <dl className={`grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 ${className}`.trim()}>
    {children}
  </dl>
);

/**
 * Semantic read-only fact for DetailFieldGrid.
 *
 * Uses dt/dd typography without control chrome. Bordered `.field-display`
 * pills are reserved for sensitive reveal and edit-adjacent contexts.
 */
export const DetailField = ({
  label,
  value,
  children,
  span = 'auto',
  multiline = false,
  className = '',
  valueClassName = '',
}) => (
  <div className={`${SPAN_CLASSES[span] || SPAN_CLASSES.auto} ${className}`.trim()}>
    <dt className="detail-label">{label}</dt>
    <dd
      className={`detail-value ${
        multiline ? 'detail-value-multiline' : ''
      } ${valueClassName}`.trim()}
    >
      {fieldContent(children, value)}
    </dd>
  </div>
);

/**
 * Badge-only detail fact.
 */
export const DetailBadgeField = ({
  label,
  children,
  span = 'auto',
  className = '',
}) => (
  <div className={`${SPAN_CLASSES[span] || SPAN_CLASSES.auto} ${className}`.trim()}>
    <dt className="detail-label">{label}</dt>
    <dd className="min-h-[24px] flex flex-wrap items-center gap-1.5">
      {children || '—'}
    </dd>
  </div>
);

export default DetailFieldGrid;
